<script setup lang="ts">
import { BaseDialog } from '@/components/Modals/Dialog'
import store from '@/store'
import { EShuttleEpcActions } from '@/store/shuttleEpcStore/ShuttleEpcStoreTypes'
import { EStoreModules } from '@/store/storeType'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import PrimaryButton from '../../../../components/Buttons/PrimaryButton.vue'
import CustomField from '../../../../components/Fields/CustomField.vue'
import InputField from '../../../../components/Fields/InputField.vue'

const { t } = useI18n()

type Props = {
    loading?: boolean
}
defineProps<Props>()
type Emits = {
    (e: 'refresh'): void
}
const emit = defineEmits<Emits>()

const isCreateDialogOpen = ref(false)
const newEpc = ref('')

const openCreateDialog = () => {
    newEpc.value = ''
    isCreateDialogOpen.value = true
}

const createShuttleEpc = () => {
    if (!newEpc.value.trim()) return
    store
        .dispatch(
            `${EStoreModules.SHUTTLE_EPC}/${EShuttleEpcActions.CREATE_SHUTTLE_EPC}`,
            newEpc.value.trim()
        )
        .then(() => {
            isCreateDialogOpen.value = false
            newEpc.value = ''
            emit('refresh')
        })
}
</script>

<template>
    <PrimaryButton
        icon-left="plus"
        :label="$t('shuttleEpc.buttons.create')"
        @click="openCreateDialog" />

    <BaseDialog
        :title="t('shuttleEpc.dialog.createTitle')"
        :open="isCreateDialogOpen"
        :confirmLabel="t('common.create')"
        :disabled="!newEpc.trim()"
        :loading="loading"
        @close="isCreateDialogOpen = false"
        @confirm="createShuttleEpc">
        <template #content>
            <CustomField :label="t('shuttleEpc.model.epc')">
                <InputField
                    v-model="newEpc"
                    :placeholder="t('shuttleEpc.dialog.epcPlaceholder')"
                    @keyup.enter="createShuttleEpc" />
            </CustomField>
        </template>
    </BaseDialog>
</template>
